import PropTypes from "prop-types";

import { defineMessages, injectIntl, FormattedMessage } from "react-intl";

import { Helmet } from "react-helmet";

import ImmutablePropTypes from "react-immutable-proptypes";
import ImmutablePureComponent from "react-immutable-pure-component";
import { connect } from "react-redux";

import { debounce } from "lodash";

import { fetchFollowRequests, expandFollowRequests } from "flavours/glitch/actions/accounts";
import ColumnHeader from "flavours/glitch/components/column_header";
import PageFrame from "flavours/glitch/features/ui/components/page_frame";
import ScrollableList from "flavours/glitch/components/scrollable_list";
import { me } from "flavours/glitch/initial_state";

import AccountAuthorizeContainer from "./containers/account_authorize_container";






const messages = defineMessages({
  heading: { id: "column.follow_requests", defaultMessage: "Follow requests" },
});

const mapStateToProps = state => ({
  accountIds: state.getIn(["user_lists", "follow_requests", "items"]),
  isLoading: state.getIn(["user_lists", "follow_requests", "isLoading"], true),
  hasMore: !!state.getIn(["user_lists", "follow_requests", "next"]),
  locked: !!state.getIn(["accounts", me, "locked"]),
  domain: state.getIn(["meta", "domain"]),
});

class FollowRequests extends ImmutablePureComponent {

  static propTypes = {
    params: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
    hasMore: PropTypes.bool,
    isLoading: PropTypes.bool,
    accountIds: ImmutablePropTypes.list,
    locked: PropTypes.bool,
    domain: PropTypes.string,
    intl: PropTypes.object.isRequired,
    multiColumn: PropTypes.bool,
    embedded: PropTypes.bool,
  };

  UNSAFE_componentWillMount () {
    this.props.dispatch(fetchFollowRequests());
  }

  handleLoadMore = debounce(() => {
    this.props.dispatch(expandFollowRequests());
  }, 300, { leading: true });

  render () {
    const { intl, accountIds, hasMore, multiColumn, embedded, locked, domain, isLoading } = this.props;
    const title = intl.formatMessage(messages.heading);

    const emptyMessage = <FormattedMessage id='empty_column.follow_requests' defaultMessage="You don't have any follow requests yet. When you receive one, it will show up here." />;
    const unlockedPrependMessage = !locked && accountIds.size > 0 && (
      <div className='follow_requests-unlocked_explanation'>
        <FormattedMessage
          id='follow_requests.unlocked_explanation'
          defaultMessage='Even though your account is not locked, the {domain} staff thought you might want to review follow requests from these accounts manually.'
          values={{ domain: domain }}
        />
      </div>
    );

    return (
      <PageFrame embedded={embedded} bindToDocument={!multiColumn} label={title}>
        <ColumnHeader icon='user-plus' title={title} multiColumn={multiColumn} showBackButton />

        <ScrollableList
          scrollKey='follow_requests'
          onLoadMore={this.handleLoadMore}
          hasMore={hasMore}
          isLoading={isLoading}
          showLoading={isLoading && accountIds.size === 0}
          emptyMessage={emptyMessage}
          bindToDocument={!multiColumn && !embedded}
          prepend={unlockedPrependMessage}
        >
          {accountIds.map(id =>
            <AccountAuthorizeContainer key={id} id={id} />,
          )}
        </ScrollableList>

        <Helmet>
          <meta name='robots' content='noindex' />
        </Helmet>
      </PageFrame>
    );
  }

}

export default connect(mapStateToProps)(injectIntl(FollowRequests));
